import RadioItemCard from 'src/components/primitives/RadioGroup/RadioItemCard';
import RadioItemStandard from 'src/components/primitives/RadioGroup/RadioItemStandard';
import {
	RadioItemProps,
	RadioGroupVariant,
} from 'src/components/primitives/RadioGroup/types';

interface Props<T extends string> extends RadioItemProps<T> {
	variant: RadioGroupVariant;
}

export default function RadioItem<T extends string>({
	variant,
	...rest
}: Props<T>) {
	return variant === 'standard' ? (
		<RadioItemStandard {...rest} />
	) : (
		<RadioItemCard {...rest} />
	);
}
